import service from '@/utils/request'

export function examGradeList(data) {
  return service({
    url: '/api/exam_grade/list',
    method: 'post',
    data
  })
}

export function examGradeAdd(data) {
  return service({
    url: '/api/exam_grade/add',
    method: 'post',
    data
  })
}

export function examGradeEdit(data) {
  return service({
    url: '/api/exam_grade/edit',
    method: 'post',
    data
  })
}

export function examGradeDelete(data) {
  return service({
    url: '/api/exam_grade/delete',
    method: 'post',
    data
  })
}

export function examGradeDetail(data) {
  return service({
    url: '/api/exam_grade/detail',
    method: 'post',
    data
  })
}

export function examGradeScoreSum(data) {
  return service({
    url: '/api/exam_grade/score/sum',
    method: 'post',
    data
  })
}

export function examGradeUserNewInfo(data) {
  return service({
    url: '/api/exam_grade/user/new/info',
    method: 'post',
    data
  })
}